import { useCallback, useState } from "react";
import type { CompilationSong } from "@memento/types/compilation-song";
import type { Volume } from "@memento/types/render-config";
import { type SetEditor } from "src/components/Renderer/RendererProvider";

export type UseMusicType = ReturnType<typeof useMusic>;

export const useMusic = (setEditor: SetEditor) => {
  // This is sort of a hacky way to tell SongAudioPlayer to pause a song if it's
  // rendered. This is mostly used so that when a user starts the preview
  // player, we can pause song that SongAudioPlayer is playing. If we increment
  // this counter, SongAudioPlayer can respond and pause. We don't want to set a
  // play/pause state because we could end up in a "playing" state without user
  // input (useEffect runs on render and if we have an old "playing" state, it
  // will start playing on render).
  const [pauseSongAudioPlayerCounter, setPauseSongAudioPlayerCounter] =
    useState(0);

  function setMusicEnabled(enabled: boolean) {
    setEditor((prev) => ({
      ...prev,
      music: {
        ...prev.music,
        enabled,
      },
    }));
  }

  function setVolumeDuringClips(volumeDuringClips: Volume) {
    setEditor((prev) => ({
      ...prev,
      music: {
        ...prev.music,
        volumeDuringClips,
      },
    }));
  }

  function setSong(song: CompilationSong) {
    setEditor((prev) => ({
      ...prev,
      music: {
        ...prev.music,
        song,
      },
    }));
  }

  const pauseSongAudioPlayer = useCallback(() => {
    setPauseSongAudioPlayerCounter((prev) => prev + 1);
  }, []);

  return {
    setMusicEnabled,
    setVolumeDuringClips,
    setSong,
    pauseSongAudioPlayerCounter,
    pauseSongAudioPlayer,
  };
};
